<template>
  <section class="service-cta position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" :style="{ backgroundImage: `url('${decorativeShapes.shape1}')` }"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" :style="{ backgroundImage: `url('${decorativeShapes.shape2}')` }"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-3 position-absolute" :style="{ backgroundImage: `url('${decorativeShapes.shape3}')` }"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-4 position-absolute" :style="{ backgroundImage: `url('${decorativeShapes.shape4}')` }"></div>
    </div>
    
    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="cta-content text-center">
            <div class="cta-title">
              <h2>{{ ctaData.title }}</h2>
            </div>
            <div class="cta-description">
              <p>{{ ctaData.description }}</p>
            </div>
            <div class="cta-buttons">
              <router-link :to="ctaData.primaryButton.link" class="cta-btn primary-btn">
                <i :class="ctaData.primaryButton.icon"></i> {{ ctaData.primaryButton.text }}
              </router-link>
              <router-link :to="ctaData.secondaryButton.link" class="cta-btn secondary-btn">
                <i :class="ctaData.secondaryButton.icon"></i> {{ ctaData.secondaryButton.text }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceItsCallActionComp",
  props: {
    ctaData: {
      type: Object,
      required: true,
      default: () => ({
        title: "Ready to Service Your Vehicle?",
        description: "Book an appointment today and let our expert technicians take care of your car with professional service and genuine parts.",
        primaryButton: {
          text: "Book Service",
          link: "/contact",
          icon: "icon-02"
        },
        secondaryButton: {
          text: "View All Services",
          link: "/services",
          icon: "icon-02"
        }
      })
    },
    decorativeShapes: {
      type: Object,
      required: true,
      default: () => ({
        shape1: "/shapes/shape-07.png",
        shape2: "/shapes/shape-08.png",
        shape3: "/shapes/shape-09.png",
        shape4: "/shapes/shape-10.png"
      })
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Call to Action Section */
.service-cta {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.cta-description p {
  font-size: 18px;
  color: #fff;
  max-width: 600px;
  margin: 0 auto 40px;
  line-height: 1.8;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.primary-btn {
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(246, 236, 79, 0.3);
}

.secondary-btn {
  background: transparent;
  color: #F6EC4F;
  border-color: #F6EC4F;
}

.secondary-btn:hover {
  background: #F6EC4F;
  color: #00061A;
  transform: translateY(-2px);
}

/* Decorative Patterns */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.pattern-1 {
  top: 10%;
  left: 5%;
  width: 100px;
  height: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.1;
}

.pattern-2 {
  top: 20%;
  right: 10%;
  width: 80px;
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.1;
}

.pattern-3 {
  bottom: 20%;
  left: 15%;
  width: 120px;
  height: 120px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.1;
}

.pattern-4 {
  bottom: 10%;
  right: 5%;
  width: 90px;
  height: 90px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.1;
}

/* Responsive Design */
@media (max-width: 767px) {
  .cta-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .cta-description p {
    font-size: 16px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
  
  .pattern-1,
  .pattern-2,
  .pattern-3,
  .pattern-4 {
    display: none;
  }
}

@media (max-width: 480px) {
  .cta-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
  
  .cta-description p {
    font-size: 14px;
  }
  
  .cta-btn {
    padding: 12px 24px;
    font-size: 14px;
  }
}
</style>
